export const SurahQuranData=[
    {nameOfSurah:"حمد" , countOfSurah:1},
    {nameOfSurah:"بقره" , countOfSurah:2},
    {nameOfSurah:"آل عمران" , countOfSurah:3},
    {nameOfSurah:"نسا" , countOfSurah:4},
    {nameOfSurah:"مائده" , countOfSurah:5},
    {nameOfSurah:"انعام" , countOfSurah:6},
    {nameOfSurah:"اعراف" , countOfSurah:7},
    {nameOfSurah:"انفال" , countOfSurah:8},
    {nameOfSurah:"توبه" , countOfSurah:9},
    {nameOfSurah:"یونس" , countOfSurah:10},
    {nameOfSurah:"هود" , countOfSurah:11},
    {nameOfSurah:"یوسف" , countOfSurah:12},
    {nameOfSurah:"رعد" , countOfSurah:13},
    {nameOfSurah:"ابراهیم" , countOfSurah:14},
    {nameOfSurah:"حجر" , countOfSurah:15},
    {nameOfSurah:"نحل" , countOfSurah:16},
    {nameOfSurah:"اسرا" , countOfSurah:17},
    {nameOfSurah:"کهف" , countOfSurah:18},
    {nameOfSurah:"مریم" , countOfSurah:19},
    {nameOfSurah:"طه" , countOfSurah:20},
    {nameOfSurah:"انبیا" , countOfSurah:21},
    {nameOfSurah:"حج" , countOfSurah:22},
    {nameOfSurah:"مومنین" , countOfSurah:23},
    {nameOfSurah:"نور" , countOfSurah:24},
    {nameOfSurah:"فرقان" , countOfSurah:25},
    {nameOfSurah:"شعرا" , countOfSurah:26},
    {nameOfSurah:"نمل" , countOfSurah:27},
    {nameOfSurah:"قصص" , countOfSurah:28},
    {nameOfSurah:"عنکبوت" , countOfSurah:29},
    {nameOfSurah:"روم" , countOfSurah:30},
    {nameOfSurah:"لقمان" , countOfSurah:31},
    {nameOfSurah:"سجده" , countOfSurah:32},
    {nameOfSurah:"احزاب" , countOfSurah:33},
    {nameOfSurah:"سبا" , countOfSurah:34},
    {nameOfSurah:"فاطر" , countOfSurah:35},
    {nameOfSurah:"یس" , countOfSurah:36},
    {nameOfSurah:"صافات" , countOfSurah:37},
    {nameOfSurah:"ص" , countOfSurah:38},
    {nameOfSurah:"زمر" , countOfSurah:39},
    {nameOfSurah:"غافر" , countOfSurah:40},
    {nameOfSurah:"فصلت" , countOfSurah:41},
    {nameOfSurah:"شوری" , countOfSurah:42},
    {nameOfSurah:"زخرف" , countOfSurah:43},
    {nameOfSurah:"دخان" , countOfSurah:44},
    {nameOfSurah:"جاثیه" , countOfSurah:45},
    {nameOfSurah:"احقاف" , countOfSurah:46},
    {nameOfSurah:"محمد" , countOfSurah:47},
    {nameOfSurah:"فتح" , countOfSurah:48},
    {nameOfSurah:"حجرات" , countOfSurah:49},
    {nameOfSurah:"ق" , countOfSurah:50},
    {nameOfSurah:"ذاریات" , countOfSurah:51},
    {nameOfSurah:"طور" , countOfSurah:52},
    {nameOfSurah:"نجم" , countOfSurah:53},
    {nameOfSurah:"قمر" , countOfSurah:54},
    {nameOfSurah:"الرحمن" , countOfSurah:55},
    {nameOfSurah:"واقعه" , countOfSurah:56},
    {nameOfSurah:"حدید" , countOfSurah:57},
    {nameOfSurah:"مجادله" , countOfSurah:58},
    {nameOfSurah:"حشر" , countOfSurah:59},
    {nameOfSurah:"ممتحنه" , countOfSurah:60},
    {nameOfSurah:"صف" , countOfSurah:61},
    {nameOfSurah:"جمعه" , countOfSurah:62},
    {nameOfSurah:"منافقون" , countOfSurah:63},
    {nameOfSurah:"تغابن" , countOfSurah:64},
    {nameOfSurah:"طلاق" , countOfSurah:65},
    {nameOfSurah:"تحریم" , countOfSurah:66},
    {nameOfSurah:"ملک" , countOfSurah:67},
    {nameOfSurah:"قلم" , countOfSurah:68},
    {nameOfSurah:"حاقه" , countOfSurah:69},
    {nameOfSurah:"معارج" , countOfSurah:70},
    {nameOfSurah:"نوح" , countOfSurah:71},
    {nameOfSurah:"جن" , countOfSurah:72},
    {nameOfSurah:"مزمل" , countOfSurah:73},
    {nameOfSurah:"مدثر" , countOfSurah:74},
    {nameOfSurah:"قیامت" , countOfSurah:75},
    {nameOfSurah:"انسان" , countOfSurah:76},
    {nameOfSurah:"مرسلات" , countOfSurah:77},
    {nameOfSurah:"نباء" , countOfSurah:78},
    {nameOfSurah:"نازعات" , countOfSurah:79},
    {nameOfSurah:"عبس" , countOfSurah:80},
    {nameOfSurah:"تکویر" , countOfSurah:81},
    {nameOfSurah:"انفطار" , countOfSurah:82},
    {nameOfSurah:"مطففین" , countOfSurah:83},
    {nameOfSurah:"انشقاق" , countOfSurah:84},
    {nameOfSurah:"بروج" , countOfSurah:85},
    {nameOfSurah:"طارق" , countOfSurah:86},
    {nameOfSurah:"اعلی" , countOfSurah:87},
    {nameOfSurah:"غاشیه" , countOfSurah:88},
    {nameOfSurah:"فجر" , countOfSurah:89},
    {nameOfSurah:"بلد" , countOfSurah:90},
    {nameOfSurah:"شمس" , countOfSurah:91},
    {nameOfSurah:"لیل" , countOfSurah:92},
    {nameOfSurah:"ضحی" , countOfSurah:93},
    {nameOfSurah:"شرح" , countOfSurah:94},
    {nameOfSurah:"تین" , countOfSurah:95},
    {nameOfSurah:"علق" , countOfSurah:96},
    {nameOfSurah:"قدر" , countOfSurah:97},
    {nameOfSurah:"بینه" , countOfSurah:98},
    {nameOfSurah:"زلزله" , countOfSurah:99},
    {nameOfSurah:"عادیات" , countOfSurah:100},
    {nameOfSurah:"قارعه" , countOfSurah:101},
    {nameOfSurah:"تکاثر" , countOfSurah:102},
    {nameOfSurah:"عصر" , countOfSurah:103},
    {nameOfSurah:"همزه" , countOfSurah:104},
    {nameOfSurah:"فیل" , countOfSurah:105},
    {nameOfSurah:"قریش" , countOfSurah:106},
    {nameOfSurah:"ماعون" , countOfSurah:107},
    {nameOfSurah:"کوثر" , countOfSurah:108},
    {nameOfSurah:"کافرون" , countOfSurah:109},
    {nameOfSurah:"نصر" , countOfSurah:110},
    {nameOfSurah:"مسد" , countOfSurah:111},
    {nameOfSurah:"اخلاص" , countOfSurah:112},
    {nameOfSurah:"فلق" , countOfSurah:113},
    {nameOfSurah:"ناس" , countOfSurah:114},
];